import styled from 'styled-components';

export const OfferCashbackContainer = styled.div`
    .offer-cashback-container {
        flex-direction: row;
        align-items: flex-end;
        display: block;

        &.coupon {
            text-align: center;
        }

        &.margin-child > * {
            margin: 0 2px;
            display: inline-block;
        }

        .valeur {
            color: ${props => props.theme.partnerOfferMain};
            font-weight: ${props => props.theme.partnerOfferMainTextWeight};
            font-family: ${props => props.theme.fontStackSpecial};

            strong {
                font-size: 24px;
                font-weight: ${props => props.theme.partnerOfferMainValueWeight};
            }
        }
        .aulieu,
        .jusqua {
            font-size: 16px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/offer/CashbackOfferComponentStyle.js